module.exports = __webpack_public_path__ + "img/73.775be4c2.jpg";